import React, { useMemo, useState, useCallback } from "react";
import { Route } from "react-router";
import { Layout } from "components/Layout";
import { Host } from "components/Host/Host";
import { Client } from "components/Client/Client";
import Preloader, { flatten } from "components/Preloader";
import { FONTS, IMAGES } from "constants/constants";
import { getPreloadAudio } from "constants/audio";
import 'shared/fonts.scss';

export default function App() {
    const [isLoadingComplete, setIsLoadingComplete] = useState(false);
    const isClient = window.location.pathname.startsWith("/client");

    const imagesToPreload = useMemo(() => ([
        ...flatten(IMAGES?.SHARED),
        ...(isClient ? flatten(IMAGES?.CLIENT) : flatten(IMAGES?.HOST)),
    ]), [isClient]);

    const audioToPreload = useMemo(() =>
        isClient ? [] : getPreloadAudio()
        , [isClient]);

    const handleLoadingComplete = useCallback(() => {
        setIsLoadingComplete(true);
    }, []);

    return (
        <Layout>
            <Route exact path="/" render={(props) => (
                <Host {...props} isLoadingComplete={isLoadingComplete} />
            )} />
            <Route path="/client" render={(props) => (
                <Client {...props} isLoadingComplete={isLoadingComplete} />
            )} />
            <Preloader imagesToLoad={imagesToPreload} fontsToLoad={FONTS} audioToLoad={audioToPreload} onComplete={handleLoadingComplete} />
        </Layout>
    );
}